import React, { useState, useEffect } from 'react';
import ProfileDetailForm from './profile_detail_form';
import MyBlogsEditForm from './my_blogs_edit_form';
import RecruitsEditForm from './recruits_edit_form';
import axios from 'axios';
import Loader from '../../../../components/loader.jsx';

const Edit = (props) => {
  const [profileData, setProfileData] = useState(props.profileData);
  const shouldShowRecruitTab = profileData.age_range_visibility == '1';

  const [imagePreview, setImagePreview] = useState(props.profileData.avatar_thumb || '');
  const [selectedImage, setSelectedImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [usersCircles, setUsersCircles] = useState(props.myCircle);

  const getValidTabs = () => {
    const tabs = ['profile-tab', 'mynote-tab'];
    if (shouldShowRecruitTab) {
      tabs.push('recruit-tab');
    }
    return tabs;
  };

  const [activeTab, setActiveTab] = useState(() => {
    const savedTab = localStorage.getItem('activeTab') || 'profile-tab';
    const validTabs = getValidTabs();
    return validTabs.includes(savedTab) ? savedTab : 'profile-tab';
  });

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    localStorage.setItem('activeTab', tab);
  };

  useEffect(() => {
    const validTabs = getValidTabs();
    if (!validTabs.includes(activeTab)) {
      setActiveTab('profile-tab');
      localStorage.setItem('activeTab', 'profile-tab');
    }
  }, [profileData]);
  

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedImage(file);
      const reader = new FileReader();
      reader.onload = (e) => {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const toProfilePage = () => {
    location.href = `/member/profile/${props.memberId}`;
  };

  const PreferenceChoose = () => {
    location.href = `/preferences`;
  };
  
  const handleSubmit = () => {
    setIsLoading(true);
    const formData = new FormData();
    Object.keys(profileData).map((key) => formData.append(`profile[${key}]`, profileData[key]));

    if (selectedImage) {
      formData.append('profile[avatar]', selectedImage);
    }

    axios
      .post('/api/profile/update', formData)
      .then(() => {
        alert('保存しました');
        window.location.href = `/member/profile/${props.memberId}`;
      })
      .catch((error) => {
        console.error('Error saving data:', error);
        alert('保存に失敗しました');
      })
      .finally(() => {
        setIsLoading(false);
    });
  };

  return (
    <div id="edit-view">
      {/* プロフィール画像 */}
      <div className="container col-md-8 col-lg-6 mt-3">
        <div
          id="img_field"
          className="bg-white d-flex justify-content-center align-items-center rounded-circle mx-auto"
          style={{ width: '100px', height: '100px' }}
          onClick={() => document.getElementById('upfile').click()}
        >
          {imagePreview ? (
            <img
              src={imagePreview}
              alt="プロフィール画像"
              style={{ objectFit: 'cover', width: '100%', height: '100px' }}
              className="rounded-circle"
            />
          ) : (
            <img
              src="/assets2019/img/icon_camera.svg"
              alt="デフォルトプロフィール画像"
              style={{ width: '32px', height: '32px' }}
            />
          )}
        </div>
        <input
          type="file"
          id="upfile"
          style={{ display: 'none' }}
          accept="image/jpg,image/jpeg,image/png,image/gif"
          onChange={handleImageChange}
        />
      </div>

      {/* トグルバー */}
      <div className="container mt-4 d-flex justify-content-center align-items-center">
        <div className="col-lg-8 toggle-bar d-flex justify-content-center align-items-center">
          <button
            className={`btn btn-toggle ${
              activeTab === 'profile-tab' ? 'active' : ''
            }`}
            id="profile-tab"
            onClick={() => handleTabClick('profile-tab')}
          >
            プロフィール
          </button>
          <button
            className={`btn btn-toggle ${
              activeTab === 'mynote-tab' ? 'active' : ''
            }`}
            id="mynote-tab"
            onClick={() => handleTabClick('mynote-tab')}
          >
            Myノート
          </button>
          {shouldShowRecruitTab && (
            <button
              className={`btn btn-toggle ${
                activeTab === 'recruit-tab' ? 'active' : ''
              }`}
              id="recruit-tab"
              onClick={() => handleTabClick('recruit-tab')}
            >
              {/* 募集一覧 */}
              Myイベント
            </button>
          )}
        </div>
      </div>

      {/* トグルの内容 */}
      <div className="tab-content mt-3">
        {activeTab === 'profile-tab' && (
          <ProfileDetailForm formData={profileData} onDataChange={setProfileData} />
        )}
        {activeTab === 'mynote-tab' && (
          <MyBlogsEditForm blogs={props.blogs} usersCircles={usersCircles} setUsersCircles={setUsersCircles} />
        )}
        {activeTab === 'recruit-tab' && shouldShowRecruitTab && (
          <RecruitsEditForm events={props.events}/>
        )}
      </div>
      {activeTab == 'profile-tab' ? (
        <div className="text-center mt-4 mb-4">
          {/* ローディング */}
          {isLoading && (
            <div className="d-flex justify-content-center align-items-center my-4">
              <Loader isActive={true} />
            </div>
          )}
          {/* 登録ボタン */}
          <div className="text-center mt-4 mb-4">
            <button
              onClick={toProfilePage}
              className="btn"
              style={{
                backgroundColor: 'gray',
                color: 'white',
                marginRight: '12px',
                padding: '12px 40px',
                borderRadius: '10px',
                fontSize: '16px',
                border: 'none',
              }}
            >
              戻る
            </button>
            <button
              onClick={handleSubmit}
              className="btn"
              style={{
                backgroundColor: '#FF4D5B',
                color: 'white',
                padding: '12px 40px',
                borderRadius: '10px',
                fontSize: '16px',
                border: 'none',
              }}
            >
              登録
            </button>
          </div>
          {/* お好み条件の登録 */}
          <div className="text-center mb-3 pt-3">
            <h3 
              className="mb-4"
              style={{fontSize: '16px'}}>
                お好み条件の設定を変更したい場合は、一度、上記の項目の登録を行ってから、下のボタンから変更を行ってください
            </h3>
            <button
              onClick={PreferenceChoose}
              className="btn"
              style={{
                backgroundColor: '#FFFFFF',
                color: '#FF4D5B',
                padding: '10px 30px',
                borderRadius: '10px',
                fontSize: '14px',
                border: '2px solid #FF4D5B',
                textDecoration: 'none',
              }}
            >
              お好み条件の設定はこちら
            </button>
          </div>
        </div>
      ) : (
        <div className="text-center mt-4 mb-4">
          <button
            onClick={toProfilePage}
            className="btn"
            style={{
              backgroundColor: 'gray',
              color: 'white',
              padding: '12px 40px',
              borderRadius: '10px',
              fontSize: '16px',
              border: 'none',
            }}
          >
            戻る
          </button>
        </div>
      )} 
    </div>
  );
};

export default Edit;
